// extracted by mini-css-extract-plugin
export var chevron = "_is-2";
export var dropdownItems = "_is-0";
export var item = "_is-1";